// All list consumers own their results. Single-record reads and writes retain
// Feathers-Pinia's model, clone and save behavior.
export function skipListStore(context) {
  context.params.skipStore = true
  return context
}
